import { Logger } from './client'

export const logger = new Logger()
